import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navigation from './components/ui/Navigation';
import VisualLayer from './components/visual/VisualLayer';
import HomePage from './components/routes/HomePage';
import ProjectsPage from './components/routes/ProjectsPage';
import ContactPage from './components/routes/ContactPage';

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <div className="min-h-screen bg-surface text-text-primary">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-offWhite focus:px-4 focus:py-2 focus:text-trueBlack"
      >
        Skip to main content
      </a>
      <VisualLayer />
      <Navigation />
      <RouteEffects />
      <main id="main-content" className="relative z-10 pt-28">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
